export const STATE_NORMAL = 0;
export const STATE_SENDING = 1;
export const STATE_LIMIT = 2;
